var _style, _metadata, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconWb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: 20,
    height: 20,
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    viewBox: "0 0 203 203",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n    .fil1 {fill:#772692}\n    .fil0 {fill:#EF126C}\n    .fil2 {fill:#FEFEFE;fill-rule:nonzero}\n  ")), /*#__PURE__*/React.createElement("mask", {
    id: "id0"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "id1",
    gradientUnits: "userSpaceOnUse",
    x1: 163.568,
    y1: 37.6334,
    x2: 48.3948,
    y2: 152.806
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopOpacity: 1,
      stopColor: "white"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopOpacity: 0,
      stopColor: "white"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "url(#id1)"
    },
    x: -10,
    y: -10,
    width: 223,
    height: 223
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Layer_x0020_1"
  }, _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", {
    id: "CorelCorpID_0Corel-Layer"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_248205328"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "fil0",
    d: "M166 203l-128 0c-21,0 -38,-17 -38,-37l0 -128c0,-21 17,-38 38,-38l128 0c20,0 37,17 37,38l0 128c0,20 -17,37 -37,37z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "fil1",
    style: {
      mask: "url(#id0)"
    },
    d: "M166 203l-128 0c-21,0 -38,-17 -38,-37l0 -128c0,-21 17,-38 38,-38l128 0c20,0 37,17 37,38l0 128c0,20 -17,37 -37,37z"
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "fil2",
    d: "M20 64c5,0 9,0 13,0 5,19 10,38 15,56 1,1 1,2 1,2 0,-1 1,-2 1,-3 5,-15 9,-31 14,-46 0,-3 1,-6 2,-9 4,0 8,0 11,0 5,17 10,35 15,52 1,2 2,4 2,7 0,-1 0,-1 1,-1 5,-19 10,-39 15,-58 4,0 9,0 13,0 -2,6 -3,11 -5,17 -4,16 -9,32 -13,48 -1,3 -2,7 -3,10 -5,0 -9,0 -14,0 -1,0 -1,0 -1,-1 -5,-18 -10,-36 -15,-54 -1,2 -1,5 -2,7 -5,16 -10,32 -14,48l0 0c-5,0 -10,0 -14,0 -2,-6 -4,-11 -5,-17 -6,-19 -11,-38 -16,-57 -1,0 -1,-1 -1,-1zm108 0c10,0 20,0 30,0 4,0 8,1 11,3 4,2 7,5 9,9 2,4 2,8 2,12 -1,4 -2,7 -5,10 -1,1 -2,1 -3,2 4,2 6,4 8,7 2,3 3,7 3,10 0,3 -1,7 -2,10 -2,3 -4,6 -7,8 -3,2 -7,3 -10,4 -2,0 -5,0 -7,0 -6,0 -11,0 -17,0 -4,0 -8,0 -12,0 0,-23 0,-46 0,-69 0,-2 0,-4 0,-6zm13 12c-1,0 0,1 0,2 0,6 0,12 0,17 5,0 10,0 15,0 1,0 3,0 4,0 2,0 4,-1 5,-2 3,-4 4,-10 0,-14 -1,-2 -4,-3 -7,-3 -6,0 -11,0 -17,0zm0 31c0,3 0,7 0,11 0,3 -1,6 0,10 5,-1 11,0 16,-1 2,0 4,1 7,0 3,-1 5,-4 6,-7 1,-3 1,-6 -1,-8 -2,-4 -5,-6 -9,-6 -6,1 -13,0 -19,1z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWb);
export default __webpack_public_path__ + "static/media/iconWB.a19759a8d2a3aac1f10591f029f00a5e.svg";
export { ForwardRef as ReactComponent };